import type { Option } from '../types';

export const sexOptions: Option[] = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
];

export const teamGenderTypeOptions: Option[] = [
  { value: 'mens', label: "Men's" },
  { value: 'womens', label: "Women's" },
  { value: 'mixed', label: 'Mixed' },
];

export const teamColorOptions: Option[] = [
  { value: 'blue', label: 'Blue' },
  { value: 'green', label: 'Green' },
  { value: 'purple', label: 'Purple' },
  { value: 'orange', label: 'Orange' },
  { value: 'red', label: 'Red' },
  { value: 'teal', label: 'Teal' },
  { value: 'gold', label: 'Gold' },
  { value: 'gray', label: 'Gray' },
];

export const usStateOptions: Option[] = [
  'AK',
  'AL',
  'AR',
  'AS',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'GU',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MP',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UM',
  'UT',
  'VA',
  'VI',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
].map((abbreviation) => ({ value: abbreviation, label: abbreviation }));

export const playerTierOptions: Option[] = [
  { value: '', label: 'No Tier' },
  { value: 'tier_1', label: 'Tier 1 - stronger players' },
  { value: 'tier_2', label: 'Tier 2 - middle players' },
  { value: 'tier_3', label: 'Tier 3 - developing players' },
];

export const playerRatingBasisOptions: Option[] = [
  { value: 'edr', label: 'EDR' },
  { value: 'tier', label: 'Tiering' },
];

export const opponentRatingBasisOptions: Option[] = [
  { value: 'avg_edr', label: 'Average EDR' },
  { value: 'subjective', label: 'Subjective Difficulty' },
];

export const opponentSubjectiveDifficultyOptions: Option[] = [
  { value: '1', label: 'Easy' },
  { value: '3', label: 'Even' },
  { value: '5', label: 'Tough' },
];

export const singlesPreferenceOptions: Option[] = [
  { value: 'yes', label: 'Yes' },
  { value: 'if_possible', label: 'If Possible' },
  { value: 'no', label: 'No' },
];

export const backToBackMatchDayToleranceOptions: Option[] = [
  { value: 'no', label: 'No' },
  { value: 'if_needed', label: 'If Needed' },
  { value: 'yes', label: 'Yes' },
];

export const teamPriorityOptions: Option[] = [
  { value: 'primary', label: 'Primary' },
  { value: 'normal', label: 'Normal' },
  { value: 'secondary', label: 'Secondary' },
];

export const advancementTypeOptions: Option[] = [
  { value: 'advancing', label: 'Advancing' },
  { value: 'non_advancing', label: 'Non-Advancing' },
];

export const matchPlanningPriorityOptions: Option[] = [
  { value: 'development', label: 'Development' },
  { value: 'normal', label: 'Normal' },
  { value: 'important', label: 'Important' },
  { value: 'must_win', label: 'Must Win' },
];

export const rosterStatusOptions: Option[] = [
  { value: 'active', label: 'Active' },
  { value: 'substitute', label: 'Substitute' },
  { value: 'inactive', label: 'Inactive' },
];

export const registrationStatusOptions: Option[] = [
  { value: 'Unknown', label: 'Unknown' },
  { value: 'Not Registered', label: 'Not Registered' },
  { value: 'Registered', label: 'Registered' },
  { value: 'Not Required', label: 'Not Required' },
];

export const assignmentRoleOptions: Option[] = [
  { value: 'captain', label: 'Captain' },
  { value: 'co_captain', label: 'Co-Captain' },
  { value: 'viewer', label: 'Viewer' },
];

export const appUserRoleOptions: Option[] = [
  { value: 'admin', label: 'Admin' },
  { value: 'captain', label: 'Captain' },
  { value: 'co_captain', label: 'Co-Captain' },
  { value: 'viewer', label: 'Viewer' },
  { value: 'player', label: 'Player' },
];

export const lineTypeOptions: Option[] = [
  { value: 'singles', label: 'Singles' },
  { value: 'doubles', label: 'Doubles' },
  { value: 'mixed_doubles', label: 'Mixed Doubles' },
  { value: 'other', label: 'Other' },
];

export const matchClassificationOptions: Option[] = [
  { value: 'regular_season', label: 'Regular Season' },
  { value: 'playoff', label: 'Playoff' },
  { value: 'tournament', label: 'Tournament' },
  { value: 'practice', label: 'Practice' },
  { value: 'scrimmage', label: 'Scrimmage' },
  { value: 'other', label: 'Other' },
];

export const matchSiteTypeOptions: Option[] = [
  { value: 'Unknown', label: 'Unknown' },
  { value: 'Home', label: 'Home' },
  { value: 'Away', label: 'Away' },
  { value: 'Neutral', label: 'Neutral' },
];

export const matchStatusOptions: Option[] = [
  { value: 'Draft', label: 'Draft' },
  { value: 'Scheduled', label: 'Scheduled' },
  { value: 'Postponed', label: 'Postponed' },
  { value: 'Rescheduled', label: 'Rescheduled' },
  { value: 'Scores Entered', label: 'Scores Entered' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Cancelled', label: 'Cancelled' },
];

export const lineupStatusOptions: Option[] = [
  { value: 'Not Started', label: 'Not Started' },
  { value: 'Draft', label: 'Draft' },
  { value: 'Published', label: 'Published' },
];

export const availabilityStatusOptions: Option[] = [
  { value: 'available', label: 'Available' },
  { value: 'maybe', label: 'Maybe' },
  { value: 'unknown', label: 'Unknown' },
  { value: 'not_available', label: 'Not Available' },
];

export const participationCancellationTypeOptions: Option[] = [
  { value: 'cancelled_early', label: 'Early' },
  { value: 'cancelled_late', label: 'Late' },
];

export const participationEventReasonOptions: Option[] = [
  { value: 'Injury', label: 'Injury' },
  { value: 'Illness', label: 'Illness' },
  { value: 'Work', label: 'Work' },
  { value: 'Family', label: 'Family' },
  { value: 'Travel', label: 'Travel' },
  { value: 'Personal', label: 'Personal' },
  { value: 'Other', label: 'Other' },
];

export const participationEventTypeOptions: Option[] = [
  { value: 'played', label: 'Played' },
  { value: 'cancelled_early', label: 'Cancelled Early' },
  { value: 'cancelled_late', label: 'Cancelled Late' },
  { value: 'late_substitute', label: 'Late Substitute' },
  { value: 'standby_promotion', label: 'Standby Promotion' },
  { value: 'administrative_adjustment', label: 'Administrative Adjustment' },
];

export const resultStatusOptions: Option[] = [
  { value: 'Not Started', label: 'Not Started' },
  { value: 'Draft', label: 'Draft' },
  { value: 'Confirmed', label: 'Confirmed' },
  { value: 'Submitted', label: 'Submitted' },
];

export const teamResultOptions: Option[] = [
  { value: 'Unknown', label: 'Unknown' },
  { value: 'Win', label: 'Win' },
  { value: 'Loss', label: 'Loss' },
  { value: 'Tie', label: 'Tie' },
];

export const lineResultOptions: Option[] = [
  { value: 'Not Entered', label: 'Not Entered' },
  { value: 'Win', label: 'Win' },
  { value: 'Loss', label: 'Loss' },
  { value: 'Default by Opponent', label: 'Default by Opponent' },
  { value: 'Default by Us', label: 'Default by Us' },
  { value: 'Retired Win', label: 'Retired Win (opponent retired)' },
  { value: 'Retired Loss', label: 'Retired Loss (our player retired)' },
  { value: 'Double Default', label: 'Double Default' },
];

export const feeTypeOptions: Option[] = [
  { value: 'Court Fees', label: 'Court Fees' },
  { value: 'Practice Fees', label: 'Practice Fees' },
  { value: 'Shirt', label: 'Shirt' },
  { value: 'Gift', label: 'Gift' },
  { value: 'League Fees', label: 'League Fees' },
  { value: 'Social Event', label: 'Social Event' },
  { value: 'Other', label: 'Other' },
];

export const paymentStatusOptions: Option[] = [
  { value: 'Unpaid', label: 'Unpaid' },
  { value: 'Partially Paid', label: 'Partially Paid' },
  { value: 'Paid', label: 'Paid' },
  { value: 'Waived', label: 'Waived' },
];

export const paymentMethodOptions: Option[] = [
  { value: 'Cash', label: 'Cash' },
  { value: 'Venmo', label: 'Venmo' },
  { value: 'Zelle', label: 'Zelle' },
  { value: 'Check', label: 'Check' },
  { value: 'Other', label: 'Other' },
];

export const legacyParticipationEventTypeLabels: Record<string, string> = {
  scheduled: 'Scheduled',
  replacement: 'Late Substitute',
  administrative_correction: 'Administrative Adjustment',
};
